"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundarySourceTypeSchema = exports.BoundarySourceType = void 0;
const zod_1 = require("zod");
var BoundarySourceType;
(function (BoundarySourceType) {
    BoundarySourceType["Conditional"] = "conditional";
    BoundarySourceType["Permanent"] = "permanent";
})(BoundarySourceType || (exports.BoundarySourceType = BoundarySourceType = {}));
exports.BoundarySourceTypeSchema = zod_1.z.nativeEnum(BoundarySourceType);
//# sourceMappingURL=BoundarySourceType.js.map